import React from 'react';
import PropTypes from 'prop-types';
import { Image, Container } from 'semantic-ui-react';
import { useIntl, defineMessages } from 'react-intl';
import { flattenToAppURL } from '@plone/volto/helpers/Url/Url';
import UniversalLink from '@plone/volto/components/manage/UniversalLink/UniversalLink';
import { Icon } from '@redturtle/iovisit-theme/components';

const messages = defineMessages({
  stepNumber: {
    id: 'itinerary_step-number',
    defaultMessage: 'Tappa {stepNumber}',
  },
  discover: { id: 'itinerary_step_discover', defaultMessage: 'Scopri' },
});

const TappaCollapsed = ({ step, stepNumber }) => {
  const intl = useIntl();

  return (
    <div className="step">
      {/* image */}
      {step.image?.scales?.large?.download && (
        <Image
          src={flattenToAppURL(step.image.scales.large.download)}
          alt={step.title}
          loading="lazy"
        />
      )}
      <Container>
        <div className="step-content">
          <div className="step-text">
            <div className="step-body">
              <div className="step-title">
                {intl.formatMessage(messages.stepNumber, { stepNumber })}
              </div>
              <h3>{step.title}</h3>
              {step.text && (
                <div
                  className="text"
                  dangerouslySetInnerHTML={{
                    __html: step.text.data,
                  }}
                />
              )}
            </div>
            {step.point_of_interest?.length > 0 && (
              <div className="step-more">
                <UniversalLink item={step.point_of_interest[0]}>
                  {intl.formatMessage(messages.discover)}
                </UniversalLink>
              </div>
            )}
          </div>
        </div>
      </Container>
    </div>
  );
};

TappaCollapsed.propTypes = {
  path: PropTypes.string.isRequired,
};
export default TappaCollapsed;
